  document.addEventListener('DOMContentLoaded', function () {
            var swiperThumbs = new Swiper('.pg-thumb-slider', {
                loop: true,
              direction: "vertical",
                spaceBetween: 10,
               allowTouchMove: false
                
               
            });
            var swiperMain = new Swiper('.pg-main-slider', {
                loop: true,
              freeMode: false,
                spaceBetween: 10,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                thumbs: {
                    swiper: swiperThumbs,
                },
            });
        });
     document.addEventListener('DOMContentLoaded', function() {
    const zoomContainers = document.querySelectorAll('.zoom-container');

    zoomContainers.forEach(container => {
        const img = container.querySelector('img');

        container.addEventListener('mousemove', function(event) {
            const rect = container.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;
            const moveX = (x / rect.width) * 100;
            const moveY = (y / rect.height) * 100;
            img.style.transformOrigin = `${moveX}% ${moveY}%`;
        });

        container.addEventListener('mouseleave', function() {
            img.style.transformOrigin = 'center center';
        });
    });
});